var helpers = {
  fb: function () {
    window.fbAsyncInit = function () {
      FB.init({
        appId: "1677177309186429",
        xfbml: true,
        version: "v2.2",
      });
    };
    (function (d, s, id) {
      var js,
        fjs = d.getElementsByTagName(s)[0];
      if (d.getElementById(id)) {
        return;
      }
      js = d.createElement(s);
      js.id = id;
      js.src = "//connect.facebook.net/en_US/sdk.js";
      fjs.parentNode.insertBefore(js, fjs);
    })(document, "script", "facebook-jssdk");
  },

  twttr: function () {
    window.twttr = (function (d, s, id) {
      var js,
        fjs = d.getElementsByTagName(s)[0],
        t = window.twttr || {};
      if (d.getElementById(id)) return;
      js = d.createElement(s);
      js.id = id;
      js.src = "https://platform.twitter.com/widgets.js";
      fjs.parentNode.insertBefore(js, fjs);

      t._e = [];
      t.ready = function (f) {
        t._e.push(f);
      };

      return t;
    })(document, "script", "twitter-wjs");
  },

  is_json_string: function (str) {
    try {
      var o = JSON.parse(str);
      if (o && typeof o === "object" && o !== null) {
        return true;
      } else {
        return false;
      }
    } catch (e) {
      return false;
    }
  },

  array_unique: function (arr) {
    var result = [];
    for (var i = 0; i < arr.length; i++) {
      if (result.indexOf(arr[i]) == -1) {
        result.push(arr[i]);
      }
    }
    return result;
  },

  is_valid_email: function (email) {
    var pattern = new RegExp(
      /^((([a-z]|\d|[!#\$%&'\*\+\-\/=\?\^_`{\|}~]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])+(\.([a-z]|\d|[!#\$%&'\*\+\-\/=\?\^_`{\|}~]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])+)*)|((\x22)((((\x20|\x09)*(\x0d\x0a))?(\x20|\x09)+)?(([\x01-\x08\x0b\x0c\x0e-\x1f\x7f]|\x21|[\x23-\x5b]|[\x5d-\x7e]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(\\([\x01-\x09\x0b\x0c\x0d-\x7f]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]))))*(((\x20|\x09)*(\x0d\x0a))?(\x20|\x09)+)?(\x22)))@((([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))\.)+(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))\.?$/i
    );
    return pattern.test(email);
  },

  validate: function (form) {
    var error_msg = "";
    var errors = [];
    var coords_set = true;

    $.each(form.find("[required]").not("[disabled]"), function () {
      if ($(this).val() == "" || $(this).val() == "0") {
        $(this).addClass("error").closest(".select").addClass("error");
        errors.push(translations.required);
      }

      if ($(this).closest(".checkbox").length && !$(this).is(":checked")) {
        $(this).addClass("error");
        errors.push(translations.required);
      }

      if ($(this).attr("type") == "email") {
        if (!helpers.is_valid_email($(this).val())) {
          $(this).addClass("error");

          errors.push(translations.valid_email);
        }
      }
    });

    errors = helpers.array_unique(errors);

    if (errors.length && form.find(".form__errors").length) {
      var errorHtml = "";

      $.each(errors, function (index, value) {
        errorHtml += "<p>" + value + "</p>";
      });

      form.find(".form__errors").html(errorHtml);
    }

    return !errors.length;
  },

  set_cookie: function (cname, cvalue, exdays) {
    var d = new Date();
    d.setTime(d.getTime() + exdays * 24 * 60 * 60 * 1000);
    var expires = "expires=" + d.toUTCString();
    +"path=/;";
    document.cookie = cname + "=" + cvalue + "; " + expires;
  },

  get_cookie: function (cname) {
    var name = cname + "=";
    var ca = document.cookie.split(";");
    for (var i = 0; i < ca.length; i++) {
      var c = ca[i];
      while (c.charAt(0) == " ") c = c.substring(1);
      if (c.indexOf(name) == 0) return c.substring(name.length, c.length);
    }
    return "";
  },
};

export default helpers;
